/**
 * Normalises a client-side search term so it matches the backend's behaviour.
 *
 * Most lists in this panel are filtered in memory — the server returns the whole
 * dataset and the page filters it — so a search string never reaches the axios
 * interceptor and was never trimmed. Typing "  John  " then searched for the
 * literal "  john  " and matched nothing, while the same text sent to a
 * server-side endpoint would have been trimmed and matched.
 *
 * Call this on the NEEDLE (the search term), not the haystack — the data being
 * searched comes from the database and is already clean.
 *
 * Returns "" for anything that is not a string, so a null/undefined search box
 * degrades to "no filter" rather than throwing.
 */
export default function normalizeSearch(value) {
  if (typeof value !== "string") return "";
  return value.trim().toLowerCase();
}

/**
 * Same normalisation for haystack values. Kept separate so a caller can be
 * explicit about which side it is normalising, and so an already-lowercased
 * database value is not lowercased twice by accident.
 */
export function normalizeValue(value) {
  if (value === null || value === undefined) return "";
  return String(value).trim().toLowerCase();
}